import {
  createControlIdDeviceAsync,
  deleteControlIdDeviceAsync,
  getAllControlIdDeviceByLicenseAsync,
  getControlIdDeviceByIdAsync,
  updateConfigControlIdDeviceAsync,
  updateControlIdDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateControlIdDeviceAsync = () =>
  useMutation(createControlIdDeviceAsync);

export const useGetControlIdDDeviceByIdAsync = () =>
  useMutation(getControlIdDeviceByIdAsync);

export const useGetAllControlIdByLicenseAsync = () =>
  useMutation(getAllControlIdDeviceByLicenseAsync);

export const useUpdateControlIdAsync = () =>
  useMutation(updateControlIdDeviceAsync);

export const useUpdateConfigControlIdAsync = () =>
  useMutation(updateConfigControlIdDeviceAsync);

export const useDeleteControlIdAsync = () =>
  useMutation(deleteControlIdDeviceAsync);
